import React from 'react';
import ShadowContainer from '../../Componant/UiKits/Shadows';

const Shadow = () => {
  return (
    <div className='page-body'>
      <ShadowContainer />
    </div>
  );
};

export default Shadow;
